import { Box } from '@zillow/constellation-10';
import Image from 'next/image';
import starSvg from '../../images/star.svg';

export default function IconStarsGroup({ isGroupOfThreeStars }: { isGroupOfThreeStars: boolean }) {
  return (
    <>
      {isGroupOfThreeStars ? (
        // oxlint-disable-next-line constellation/no-raw-spacing-values -- `width: 75px` falls between `1800` (72px) and `1900` (76px) on the numeric sizes scale
        <Box css={{ position: 'relative', height: '2500', width: '75px' }}>
          <Image
            src={starSvg}
            alt="Star"
            width={19}
            height={19}
            style={{ position: 'absolute', top: '5px', right: '5px' }}
          />
          <Image
            src={starSvg}
            alt="Star"
            width={31}
            height={32}
            style={{ position: 'absolute', top: '20px', left: 0 }}
          />
          <Image
            src={starSvg}
            alt="Star"
            width={51}
            height={52}
            style={{ position: 'absolute', bottom: 0, right: 0 }}
          />
        </Box>
      ) : (
        // oxlint-disable-next-line constellation/no-raw-spacing-values -- `height: 70px` falls between `1700` (68px) and `1800` (72px) on the numeric sizes scale; `width: 50px` falls between `1200` (48px) and `1300` (52px) on the numeric sizes scale
        <Box css={{ position: 'absolute', height: '70px', width: '50px' }}>
          <Image
            src={starSvg}
            alt="Star"
            width={22}
            height={22}
            style={{ position: 'absolute', top: '0', left: '0' }}
          />
          <Image
            src={starSvg}
            alt="Star"
            width={36}
            height={36}
            style={{ position: 'absolute', bottom: '0', right: '0' }}
          />
        </Box>
      )}
    </>
  );
}
